import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import GroupedButtons from '@shared/components/AgeQuantitySelector/GroupedButtons';
import MinorAgesList from '@shared/components/AgeQuantitySelector/MinorAgesList';

const AgeQuantitySelector = ({
  defaultAdults = 1,
  defaultMinors = [],
  minAdults = 1,
  maxAdults = 9,
  minMinors = 0,
  maxMinors = 9,
  totalLimit,
  onChange,
  roomInfo = {},
  date,
}) => {
  const [adults, setAdults] = useState(defaultAdults);
  const [minors, setMinors] = useState(defaultMinors);

  // Ajustar array de menores automáticamente cuando cambia la cantidad
  const updateMinorsCount = newCount => {
    setMinors(prev => {
      const diff = newCount - prev.length;
      if (diff > 0) {
        return [
          ...prev,
          ...Array.from({ length: diff }, (_, i) => ({
            childNumber: prev.length + i + 1,
            age: 17,
          })),
        ];
      } else if (diff < 0) {
        return prev.slice(0, newCount);
      }
      return prev;
    });
  };

  const updateMinorAge = (age, index) => {
    setMinors(prev => prev.map((m, i) => (i === index ? { ...m, age } : m)));
  };

  // Notificar cambios al padre si se pasa onChange
  useEffect(() => {
    if (onChange) onChange({ adults, minors });
  }, [adults, minors]);

  useEffect(() => {
    setMinors(prev => prev.slice(0, maxMinors));
  }, [maxMinors]);

  const total = adults + minors.length;

  return (
    <Box>
      {/* Adultos */}
      <GroupedButtons
        label="Adultos"
        defaultValue={adults}
        minValue={minAdults}
        maxValue={maxAdults}
        value={setAdults}
        roomInfo={roomInfo}
        total={total}
        totalLimit={totalLimit}
      />

      {/* Menores */}
      <GroupedButtons
        label="Menores"
        defaultValue={minors.length}
        minValue={minMinors}
        maxValue={maxMinors}
        value={updateMinorsCount}
        roomInfo={roomInfo}
        total={total}
        totalLimit={totalLimit}
      />

      {/* Edades de menores */}
      {minors.length > 0 && (
        <MinorAgesList
          minors={minors}
          valueKey="age"
          onAgeChange={updateMinorAge}
          date={date}
        />
      )}
    </Box>
  );
};

export default AgeQuantitySelector;
